export default __webpack_public_path__ + "static/media/219.f0c32796.jpg";